"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _jsxFileName = "src/icons/CircleSocialFb.js";
var _react = require("react");
var _react2 = _interopRequireDefault(_react);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var CircleSocialFb = function CircleSocialFb(props) {
  return _react2.default.createElement("svg", Object.assign({
    className: "circle-icon",
    viewBox: "0 0 515 515"
  }, props, {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 4
    },
    __self: undefined
  }), _react2.default.createElement("title", {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 5
    },
    __self: undefined
  }, "Facebook Icon"), _react2.default.createElement("path", {
    d: "M257.47 0C115.26 0 0 115.29 0 257.5S115.26 515 257.47 515 515 399.71 515 257.5 399.69 0 257.47 0zm55.4 257.6h-36.24v129.2h-53.72V257.6h-25.53v-45.66h25.53V182.4c0-21.15 10.05-54.21 54.21-54.21l39.8.15v44.33H288c-4.7 0-11.39 2.35-11.39 12.44v26.83h40.93z",
    className: "circle-fb",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 6
    },
    __self: undefined
  }));
};
exports.default = CircleSocialFb;